var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C4.511 3 1.486 5.032 0 8C1.486 10.968 4.511 13 8 13C11.489 13 14.514 10.968 16 8C14.514 5.032 11.489 3 8 3ZM11.945 5.652C12.885 6.252 13.682 7.055 14.28 8C13.6839 8.9449 12.8866 9.74663 11.945 10.348C10.7671 11.1006 9.39837 11.5006 8.0005 11.5006C6.60263 11.5006 5.23395 11.1006 4.056 10.348C3.11486 9.74609 2.31768 8.94447 1.721 8C2.35639 6.99314 3.21962 6.14978 4.241 5.538C4.02119 6.14225 3.95028 6.79058 4.03429 7.42805C4.11829 8.06553 4.35474 8.67336 4.72358 9.20003C5.09243 9.7267 5.58281 10.1567 6.15315 10.4536C6.7235 10.7504 7.35701 10.9054 8 10.9054C8.64299 10.9054 9.2765 10.7504 9.84685 10.4536C10.4172 10.1567 10.9076 9.7267 11.2764 9.20003C11.6453 8.67336 11.8817 8.06553 11.9657 7.42805C12.0497 6.79058 11.9788 6.14225 11.759 5.538C11.821 5.575 11.883 5.613 11.944 5.652H11.945ZM8 6.5C7.99987 6.89796 7.84165 7.27956 7.56016 7.56087C7.27867 7.84217 6.89696 8.00013 6.499 8C6.10104 7.99987 5.71944 7.84165 5.43813 7.56016C5.15683 7.27867 4.99887 6.89696 4.999 6.499C4.99913 6.10104 5.15735 5.71944 5.43884 5.43813C5.72033 5.15683 6.10204 4.99887 6.5 4.999C6.89796 4.99913 7.27956 5.15735 7.56087 5.43884C7.84217 5.72033 8.00013 6.10204 8 6.5Z",
    fill: "#444C87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.5d45c518b7a1791f752f4fdf7c507a78.svg";
export { ForwardRef as ReactComponent };